import styled from '@emotion/styled'
import React from 'react'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { useKArrayInput } from 'services/hooks/useKArrayInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import MarginPercAndVatFields from '../MarginPercAndVatFields'
import { limitToOneDecimal } from './StandardPricingInput'

const PREFIX = 'VariablePricesInput'

const classes = {
  container: `${PREFIX}-container`,
  numberInput: `${PREFIX}-numberInput`,
}

const StyledDiv = styled('div')({
  [`& .${classes.container}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
  },
  [`& .${classes.numberInput}`]: {
    width: '300px',
    marginRight: '24px',
  },
})

type Props = { source?: string; style?: React.CSSProperties }

const VariablePricesInput: React.FC<Props> = ({ source, style }) => {
  const { kGetSource } = useKArrayInput<APIPriceRange>(source)

  return (
    <StyledDiv style={style}>
      <div className={classes.container}>
        <KNumberInput
          source={kGetSource('variableCost')}
          className={classes.numberInput}
          label="form.fields.variableCost"
          parse={limitToOneDecimal}
        />
        <KNumberInput
          source={kGetSource('variablePrice')}
          className={classes.numberInput}
          label="form.fields.variableCost"
          parse={limitToOneDecimal}
        />

        <MarginPercAndVatFields
          costSource={kGetSource('variableCost')}
          priceSource={kGetSource('variablePrice')}
        />
      </div>
    </StyledDiv>
  )
}

export default VariablePricesInput
